import { TranslationKeys } from '~frontend-common/i18n/english/additional-driver-subquestions.i18n';

const keys: TranslationKeys = {
  additionalDriver: {
    additionalDriver: 'le conducteur additionnel',
    yearsOld: 'Ans',
    actions: {
      add: 'Ajouter un conducteur supplémentaire',
      edit: 'Modifier',
      remove: 'Supprimer',
    },
    fields: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      birthday: 'Date de naissance',
      situation: 'Comment décririez-vous la situation de ce conducteur?',
      gender: 'Genre',
      relationship: 'Relation',
      ageFirstDriverLicense:
        'À quel âge ce conducteur a-t-il obtenu son permis de conduire (excluant le permis temporaire)?',
      occupation: 'Occupation',
      workplace: 'Employeur',
      schoolName: 'Nom de l’établissement scolaire',
    },
    titles: {
      main: "Vous pouvez ajouter jusqu'à deux conducteurs supplémentaires",
      claims:
        'Ajoutez tous les accidents de voiture dans lesquels ce conducteur a été impliqué dans les 6 dernières années.',
      drivingConvictions: 'Ajoutez toutes les contraventions reçues par ce conducteur dans les 5 dernières années.',
    },
    placeholders: {
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      birthday: 'jj/mm/aaaa',
      relationship: 'ex. Marié',
      ageFirstDriverLicense: 'ex. 18',
      occupation: 'ex. Médical',
      workplace: 'ex. Starbucks',
      schoolName: 'ex. Collège Dawson',
    },
  },
};

export default keys;
